//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import ImageRowWidget from "../ImageRowWidget/ImageRowWidget";
//  Config
import VocabProfessionalsContent from "../../../../../ConfigFiles/multilingual/VocabProfessionalsContent";
//  ----------      END   IMPORT  BLOCK       ----------

export const getProfessionalsContent = (lan) => {



  return [
    {
      id: VocabProfessionalsContent.FAQ_section_id[lan],
      title: VocabProfessionalsContent.FAQ_section_title[lan],
      chapters: [
        {
          id: VocabProfessionalsContent.FAQ_Q1_id[lan],
          title: VocabProfessionalsContent.FAQ_Q1_title[lan],
          body: VocabProfessionalsContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/45/8f/ef/458fef941245dcf1c786ec055318b9d3.jpg',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: VocabProfessionalsContent.help_section_id[lan],
      title: VocabProfessionalsContent.help_section_title[lan],
      chapters: [
        {
          id: VocabProfessionalsContent.FAQ_Q1_id[lan],
          title: VocabProfessionalsContent.FAQ_Q1_title[lan],
          body: VocabProfessionalsContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/45/8f/ef/458fef941245dcf1c786ec055318b9d3.jpg',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: VocabProfessionalsContent.privacy_section_id[lan],
      title: VocabProfessionalsContent.privacy_section_title[lan],
      chapters: [
        {
          id: VocabProfessionalsContent.FAQ_Q1_id[lan],
          title: VocabProfessionalsContent.FAQ_Q1_title[lan],
          body: VocabProfessionalsContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/45/8f/ef/458fef941245dcf1c786ec055318b9d3.jpg',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: VocabProfessionalsContent.pricing_section_id[lan],
      title: VocabProfessionalsContent.pricing_section_title[lan],
      chapters: [
        {
          id: VocabProfessionalsContent.FAQ_Q1_id[lan],
          title: VocabProfessionalsContent.FAQ_Q1_title[lan],
          body: VocabProfessionalsContent.FAQ_Q1_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/45/8f/ef/458fef941245dcf1c786ec055318b9d3.jpg',
              ]}
            />
          ),
        },
      ],
    },

  ];
};
